import type { SanityPageBuilderSection, SanityPageBuilderTechnicalComparisonItem, SanityPageBuilderTechnicalComparisonSection } from "@ouster/shared";
import { takeFirst } from "~/features/app/utils";
import { TechnicalComparisonBlockView, type TechnicalComparisonItem, type TechnicalComparisonItemLink } from "~/features/blocks/inventory/technical-comparison";
import { toCraftAsset } from "~/features/sanity/media";
import { toCraftLinkArray } from "~/features/sanity/link";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderTechnicalComparisonSection;
  };
};
export function SanityTechnicalComparisonSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const items = sectionContent.items?.map<TechnicalComparisonItem>((item: SanityPageBuilderTechnicalComparisonItem) => ({
    productImage: toCraftAsset(item.productImage),
    illustration: toCraftAsset(item.illustration),
    title: item.title,
    specs: item.specs?.map(spec => ({
      label: spec.label,
      value: spec.value
    })),
    link: takeFirst(toCraftLinkArray(item.link)),
    supportLink: takeFirst(toCraftLinkArray(item.supportLink)),
    links: item.links?.map<TechnicalComparisonItemLink>(link => ({
      link: takeFirst(toCraftLinkArray(link.link)),
      linkIcon: link.linkIcon
    }))
  }));
  return <TechnicalComparisonBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasTopDivider={sectionSettings?.hasTopDivider ?? true} isHighlighted={sectionContent.isHighlighted} items={items} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} />;
}